const hy = {
  title: 'Գործողության հաստատում',
  listIsFull: 'Պերսոնաների ցուցակը լի է',
  savedPersonasTxt: 'Պահպանված պերսոնաներ',
  personaLimit:
    'Պերսոնաների ցուցակը լի է։ Կարող եք ազատել տեղ՝ ջնջելով պերսոնաներից որևէ մեկը։',
};

export default hy;
